module.exports = __webpack_public_path__ + "img/nubeIzquierda.deeddb5f.svg";